/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_5_TitleInputs */

const en_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const es_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const de_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const zh_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const ar_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const fr_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const vi_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const sw_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const th_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const bs_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const ja_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const ko_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const pt_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const it_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const sv_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const nl_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const da_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const nb_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const fi_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const pl_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const ru_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const tr_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const hi_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const id_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const ms_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const cs_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const el_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const he_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const af_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

const hu_about_content_competitive_5_title = /** @type {(inputs: About_Content_Competitive_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR Qualifying School`)
};

/**
* | output |
* | --- |
* | "PGA TOUR Qualifying School" |
*
* @param {About_Content_Competitive_5_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_5_title = /** @type {((inputs?: About_Content_Competitive_5_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_5_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_5_title(inputs)
	if (locale === "de") return de_about_content_competitive_5_title(inputs)
	if (locale === "zh") return zh_about_content_competitive_5_title(inputs)
	if (locale === "ar") return ar_about_content_competitive_5_title(inputs)
	if (locale === "fr") return fr_about_content_competitive_5_title(inputs)
	if (locale === "vi") return vi_about_content_competitive_5_title(inputs)
	if (locale === "sw") return sw_about_content_competitive_5_title(inputs)
	if (locale === "th") return th_about_content_competitive_5_title(inputs)
	if (locale === "bs") return bs_about_content_competitive_5_title(inputs)
	if (locale === "ja") return ja_about_content_competitive_5_title(inputs)
	if (locale === "ko") return ko_about_content_competitive_5_title(inputs)
	if (locale === "pt") return pt_about_content_competitive_5_title(inputs)
	if (locale === "it") return it_about_content_competitive_5_title(inputs)
	if (locale === "sv") return sv_about_content_competitive_5_title(inputs)
	if (locale === "nl") return nl_about_content_competitive_5_title(inputs)
	if (locale === "da") return da_about_content_competitive_5_title(inputs)
	if (locale === "nb") return nb_about_content_competitive_5_title(inputs)
	if (locale === "fi") return fi_about_content_competitive_5_title(inputs)
	if (locale === "pl") return pl_about_content_competitive_5_title(inputs)
	if (locale === "ru") return ru_about_content_competitive_5_title(inputs)
	if (locale === "tr") return tr_about_content_competitive_5_title(inputs)
	if (locale === "hi") return hi_about_content_competitive_5_title(inputs)
	if (locale === "id") return id_about_content_competitive_5_title(inputs)
	if (locale === "ms") return ms_about_content_competitive_5_title(inputs)
	if (locale === "cs") return cs_about_content_competitive_5_title(inputs)
	if (locale === "el") return el_about_content_competitive_5_title(inputs)
	if (locale === "he") return he_about_content_competitive_5_title(inputs)
	if (locale === "af") return af_about_content_competitive_5_title(inputs)
	if (locale === "hu") return hu_about_content_competitive_5_title(inputs)
	return en_about_content_competitive_5_title(inputs)
});